import { defineComponent as t, openBlock as o, createBlock as r, unref as n, withCtx as u, renderSlot as p } from "vue";
import l from "./ghl-ui.es183.js";
const s = t({
  name: "UIInputGroup",
  inheritAttrs: !1
}), a = t({
  ...s,
  setup(f) {
    return (e, _) => (o(), r(n(l), null, {
      default: u(() => [
        p(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), m = a;
export {
  m as default
};
